import { render, staticRenderFns } from "./PrintingSafeReport.vue?vue&type=template&id=561892a6&scoped=true"
import script from "./PrintingSafeReport.vue?vue&type=script&lang=js"
export * from "./PrintingSafeReport.vue?vue&type=script&lang=js"
import style0 from "./PrintingSafeReport.vue?vue&type=style&index=0&id=561892a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561892a6",
  null
  
)

export default component.exports